function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0e2db",
  d: "M6 0h38a6 6 0 0 1 6 6v38a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6z"
});

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#4d4d4f",
  d: "M38.306 25.6a1.211 1.211 0 0 0-1.324 1.051v27.9a1.359 1.359 0 0 0 2.647 0v-27.9a1.211 1.211 0 0 0-1.323-1.051z",
  transform: "translate(-24.982 -21.595) translate(0 6)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#f26524",
  d: "M65.976 50.33c-7.941-3.856-15.882 3.856-23.824 0V32.8c7.941 3.856 15.882-3.856 23.824 0z",
  transform: "translate(-24.982 -21.595) translate(-2.523 -0.094)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ffcab2",
  d: "M66.047 42.465c-5.773-.72-11.547 2.736-17.32 2.016v-1.047c5.774.72 11.547-2.736 17.32-2.016zm0 2.908c-5.773-.72-11.547 2.736-17.32 2.016v-1.047c5.774.72 11.547-2.736 17.32-2.016zm-4.639 3.068c-2.681.426-5.362 1.271-8.043 1.7V49.09c2.681-.426 5.362-1.27 8.043-1.7z",
  transform: "translate(-24.982 -21.595) translate(-5.527 -4.388)"
}));

function SvgColorIconArea(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorIconArea);
export default __webpack_public_path__ + "static/media/colorIconArea.a64081cd.svg";
export { ForwardRef as ReactComponent };